/**
 * 画布 referenceable-resources API → MentionResource 映射。
 * 与 useCanvasReferenceableResources 保持一致，便于单测。
 */
import type { CanvasReferenceableResourceItem } from '@/services/api/canvas-referenceable-resources';
import type { MentionResource, MentionResourceType } from '@/types/mention';

function mapItemType(type: CanvasReferenceableResourceItem['type']): MentionResourceType {
  if (type === 'location') return 'location';
  return type;
}

export function mapCanvasReferenceableItemToMentionResource(
  item: CanvasReferenceableResourceItem
): MentionResource {
  return {
    type: mapItemType(item.type),
    elementId: item.elementId,
    elementName: item.elementName,
    tagId: item.tagId ?? undefined,
    tagLabel: item.tagLabel ?? undefined,
    resourceId: item.resourceId,
    resourceUrl: item.resourceUrl ?? undefined,
    thumbnailUrl: item.thumbnailUrl || item.resourceUrl || undefined,
    mimeType: item.mimeType ?? undefined,
    submitResourceId: item.resourceId,
    submitResourceType: item.resourceType,
    fileSize: item.fileSize ?? undefined,
    width: item.width ?? undefined,
    height: item.height ?? undefined,
    durationSeconds: item.duration ?? undefined,
    resolution: item.resolution ?? undefined,
    format: item.format ?? undefined,
    frameRate: item.frameRate ?? undefined,
    humanAssetType: item.humanAssetType ?? null,
    humanAssetStatus: item.humanAssetStatus ?? null,
    versionSeq: item.versionSeq ?? null,
  };
}
